import {FC, PropsWithChildren, useCallback, useState} from 'react';
import {NewDocumentCreationContext} from './new-document-creation.context';

type DialogState = {
  visible: boolean;
  onClose?: () => void;
};

type DialogContext = {
  visible: boolean;
  showDialog: (onClose?: () => void) => void;
  hideDialog: () => void;
};

export const NewDocumentCreationProvider: FC<PropsWithChildren> = ({children}) => {
  const {visible: isDialogVisible, showDialog, hideDialog} = useDialog();
  const {
    visible: isConfirmationDialogVisible,
    showDialog: showConfirmationDialog,
    hideDialog: hideConfirmationDialog,
  } = useDialog();

  const value = {
    createForContractHolderStepDisplayVariant: 'default' as const,
    isDialogVisible,
    showDialog,
    hideDialog,
    isConfirmationDialogVisible,
    showConfirmationDialog,
    hideConfirmationDialog,
  };

  return <NewDocumentCreationContext.Provider value={value}>{children}</NewDocumentCreationContext.Provider>;
};

const useDialog = (): DialogContext => {
  const [{visible, onClose}, setIsDialogVisible] = useState<DialogState>({visible: false});

  const showDialog = useCallback((onClose?: () => void) => {
    setIsDialogVisible({visible: true, onClose});
  }, []);

  const hideDialog = useCallback(() => {
    onClose?.();
    setIsDialogVisible({visible: false});
  }, [onClose]);

  return {visible, showDialog, hideDialog};
};
